/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Dashboard as DashboardLayout } from 'layouts';
import { Link, useNavigate, useParams } from 'react-router-dom';

import { makeStyles } from '@mui/styles';
import styles from './styles';
import {
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid2,
} from '@mui/material';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { importFile } from 'js/actions/groupActions';
import { Documents, Item } from './components';
import {
  CellTower,
  DeveloperBoard,
  EvStation,
  FileUpload,
  Power,
  Square,
} from '@mui/icons-material';
import theme from 'theme';

const useStyles = makeStyles(styles);

export default function HardwareConfiguration() {
  const intl = useIntl();
  const params = useParams();
  const classes = useStyles();
  const dispatch = useDispatch();
  const { meterId } = params;
  const [open, setOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const navigate = useNavigate();

  const handleCarge = () => {
    setOpen(true);
  };

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleFileUpload = () => {
    const formData = Object.assign(selectedFile, {
      preview: URL.createObjectURL(selectedFile),
    });

    dispatch(importFile(formData));
    setOpen(false);
    setSelectedFile(null);
  };

  const options = [
    {
      id: 0,
      destination: `/concentradors/${meterId}`,
      fontIcon: <EvStation sx={{ fontSize: '1.125em' }} />,
      meterId: meterId,
      productname: intl.formatMessage({
        id: 'app.groupsCards.hardwareConfig.concentrators',
      }),
    },
    {
      id: 1,
      destination: `/allcards/${meterId}`,
      fontIcon: <DeveloperBoard sx={{ fontSize: '1.125em' }} />,
      productname: intl.formatMessage({
        id: 'app.groupsCards.hardwareConfig.cards',
      }),
    },
    {
      id: 2,
      destination: `/allcardsHomework/${meterId}`,
      fontIcon: <Power sx={{ fontSize: '1.125em' }} />,
      productname: intl.formatMessage({
        id: 'app.groupsCards.hardwareConfig.tasks',
      }),
    },
    {
      id: 3,
      destination: `/powerfactor/${meterId}`,
      fontIcon: <Square sx={{ fontSize: '1.125em' }} />,
      productname: intl.formatMessage({
        id: 'app.groupsCards.hardwareConfig.powerFact',
      }),
    },
    {
      id: 4,
      destination: `/voltage/${meterId}`,
      fontIcon: <CellTower sx={{ fontSize: '1.125em' }} />,
      productname: intl.formatMessage({
        id: 'app.groupsCards.hardwareConfig.voltage',
      }),
    },
    {
      id: 5,
      fontIcon: <FileUpload sx={{ fontSize: '1.125em' }} />,
      onClick: () => handleCarge(),
      productname: 'Carga Masiva',
    },
  ];

  return (
    <DashboardLayout>
      <div className={classes.root}>
        <div className={classes.content}>
          <Grid2
            container={true}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            flexDirection="row"
            flexWrap="wrap"
          >
            {options.map((option, index) => (
              <Grid2
                key={index}
                style={{ maxWidth: '16%' }}
                size={2}
                onClick={option.onClick}
              >
                <Item
                  destination={option.destination}
                  state={meterId}
                  icon={option.fontIcon}
                  name={option.productname}
                />
              </Grid2>
            ))}
          </Grid2>
        </div>
        <Grid2 size={12} mt={5}>
          <Documents />
        </Grid2>
        <Dialog
          aria-describedby="alert-dialog-description"
          aria-labelledby="alert-dialog-title"
          className={classes.dialog}
          fullWidth
          maxWidth="sm"
          onClose={() => setOpen(false)}
          open={open}
        >
          <DialogTitle>
            <Chip className={classes.chip} label="Subir archivos" />
          </DialogTitle>
          <DialogContent
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '300px',
              position: 'relative',
            }}
          >
            <Link
              color="secondary"
              href="https://documentos-metimur.s3.us-west-2.amazonaws.com/importandor/Importador_de_Grupos_Tarjetas_y_Cargas_.pdf"
              style={{
                position: 'absolute',
                top: '1rem',
                fontWeight: 700,
                fontSize: '1.2rem',
                fontFamily: 'Roboto, Helvetica, Arial',
              }}
              target="_blank"
              underline="none"
            >
              Ver Instrucciones
            </Link>
            <input
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              id="fileSelect"
              onChange={handleFileChange}
              style={{ backgroundColor: theme.palette.background.paper }}
              type="file"
            />
          </DialogContent>
          <DialogActions>
            <Button
              color="secondary"
              disabled={!selectedFile}
              onClick={handleFileUpload}
              variant="contained"
            >
              Subir Archivos
            </Button>
            <Button
              color="secondary"
              onClick={() => setOpen(false)}
              variant="contained"
            >
              Cancelar
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </DashboardLayout>
  );
}
